const PASSWORD_SETUP_FLOW_TYPE = {
    BY_MANAGER: 1 << 0,
    BY_EMAIL: 1 << 1,
}

export default PASSWORD_SETUP_FLOW_TYPE;